import type { FC } from "react";

import { noop } from "lodash";

import type { ITableCellProps } from "../interfaces/ITableCellProps";

interface ILinkWithGenericDisplayCellProps extends ITableCellProps {
    onClick?: () => void;
}

/**
 * @deprecated Use TextAnchorCell from @similarweb/pro-logic-components instead
 * @see {@link https://gitlab.int.similarweb.io/pro-frontend/pro-logic-components/-/blob/master/src/table/cells/components/core/TextAnchorCell/TextAnchorCell.tsx}
 */
export const LinkWithGenericDisplayCell: FC<ILinkWithGenericDisplayCellProps> = ({ onClick = noop, value }) => {
    const { displayText, link } = value;

    return (
        <div className="link-cell cell-padding cell-innerText">
            <a
                onClick={onClick}
                href={link}
                target="_blank"
                rel="noreferrer"
            >
                {displayText}
            </a>
        </div>
    );
};
LinkWithGenericDisplayCell.displayName = "LinkWithGenericDisplayCell";
